export default __webpack_public_path__ + "static/media/our-story-img1.c3e1529a.jpg";